<template>
    <hr class="my-6 hr-grey" />
    <ion-row>
        <ion-col class="flex items-center justify-between">
                <ion-text class="text-md font-bold ion-text-brand"
                >{{ biometryName }} </ion-text
                >
                <ion-text
                :class="`rounded flex items-center bg-notice-${bioStorage ? 'green' : 'danger'}`"
                >
                <ion-icon
                :src="`/assets/general/icon-${bioStorage ? 'correct' : 'incorrect'}.svg`"
                class="w-[14px] pl-2"
                ></ion-icon>
                <small :class="`p-1 pr-2 bold text-notice-${bioStorage ? 'green' : 'danger'}`">{{ bioStorage ? "Enabled" : "Disabled" }}</small>
            </ion-text>
        </ion-col>
        
    </ion-row>

    <ion-row>
        <ion-col>
            <ion-text class="text-[13px] ion-text-brand mt-1 block"
            >
            Use {{ biometryName }} to log in to your Jacaranda Finance account instead of your password.
            </ion-text
            >
        </ion-col>
    </ion-row>

    <ion-row>
        <ion-col>
            <div class="ml-6" v-if="loading">
                <ion-spinner name="dots" color="primary"></ion-spinner>
            </div>
            <div v-else>
                <button
                expand="block"
                fill="outline"
                class="button-outline button-icon button-icon-security mt-6 mb-0"
                data-cy="security-details-button-mfa"
                @click="toggleBio">
                <span class="block capitalize text-[14px] height-[60px]"
                >{{ !bioStorage ? "Enable" : "Disable" }} {{ biometryName }}</span
                >
                </button>
            </div>
        </ion-col>
    </ion-row>

</template>

<script setup>
import { useBiometryAuth } from "@/composables/biometryAuth";
import { useMixed } from "@/composables/mixed";
import { useSecureStorage } from "@/composables/secureStorage";
import router from "@/router";
import { onMounted, ref } from "vue";
const { biometryName } = useBiometryAuth();
const { keys, getStorage, removeStorage } = useSecureStorage();
const bioStorage = ref(null);
const { recordSecurityEvent, securityEventKeys } = useMixed();
const loading = ref(false);
const toggleBio = () => {
    // Surely we can always just enable/deactivate FaceID if logging fails?
    if( bioStorage.value ) {
        loading.value = true;
        recordSecurityEvent(securityEventKeys.BiometricsDisabled, {
            "is_biometrics_enabled": false
        })
        .catch((error) => {
            console.error(error);
        })
        .finally(() => {
            removeStorage({ key: keys.bio })
            bioStorage.value = null;
            loading.value = false;
        });
    } else {
        router.push({ name: "SetBio" }); 
    }
};
onMounted(async () => {
    try {
        bioStorage.value = await getStorage({ key: keys.bio });
    } catch(error) {
        bioStorage.value = null;
    }
});
</script>
